import { z } from 'zod'
import type { AssetsLink } from '#/domain/assetsLink/AssetsLink'

export const AssetsLinkDtoSchema = z
  .object({
    Id: z.string().optional(),
    ExpiredAt: z.string(),
    OrganizationId: z.string(),
    CreatedBy: z.string().optional(),
    UrlAddr: z.string().optional(),
  })
  .transform((raw): AssetsLink => ({
    Id: raw.Id,
    ExpiredAt: raw.ExpiredAt,
    OrganizationId: raw.OrganizationId,
    CreatedBy: raw.CreatedBy,
    UrlAddr: raw.UrlAddr,
  }))

export type AssetsLinkResponseDto = z.input<typeof AssetsLinkDtoSchema>

export function toDomain(raw: AssetsLinkResponseDto): AssetsLink {
  return AssetsLinkDtoSchema.parse(raw)
}
